import { mix, clamp, mixColor, createPathMorph, createSvg, createMotionSvg, createMotionLine, createMotionPath, createMotionEllipse, NS, INK, PINK, easeMotion, setMotionPaint, phenomenonCrescentPath, quadrantPath, academicTrianglePath } from './helpers.js';


function setDashedStroke(node) {
    node.setAttribute("fill", "none");
    node.setAttribute("stroke", INK);
    node.setAttribute("stroke-opacity", "0.5");
    node.setAttribute("stroke-width", "4");
    node.setAttribute("stroke-linecap", "round");
    node.setAttribute("stroke-linejoin", "round");
    node.setAttribute("stroke-dasharray", "1 12");
}

function renderSocialPhenomenon() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);

    const left = createMotionPath(group, phenomenonCrescentPath(85.11, 84.82, 84.82, 140.325, 84.82, "left"));
    const right = createMotionPath(group, phenomenonCrescentPath(194.94, 84.82, 84.82, 140.325, 84.82, "right"));
    const center = createMotionPath(
        group,
        "M223.439 84.8168C223.439 130.555 186.227 167.634 140.325 167.634C94.4227 167.634 57.2114 130.555 57.2114 84.8168C57.2114 39.0783 94.4227 2 140.325 2C186.227 2 223.439 39.0783 223.439 84.8168Z",
    );
    const lineSpecs = [
        { start: [120.338, 12.817, 158.732, 12.817], end: [110.338, 12.817, 148.732, 12.817] },
        { start: [97.662, 23.6621, 181.408, 23.6621], end: [87.662, 23.6621, 171.408, 23.6621] },
        { start: [88.7888, 35.4931, 190.282, 35.4931], end: [78.7888, 35.4931, 180.282, 35.4931] },
        { start: [76.9578, 48.31, 202.113, 48.31], end: [66.9578, 48.31, 192.113, 48.31] },
        { start: [66.1128, 59.155, 212.958, 59.155], end: [56.1128, 59.155, 202.958, 59.155] },
        { start: [66.1128, 70.0001, 212.958, 70.0001], end: [56.1128, 70.0001, 202.958, 70.0001] },
        { start: [66.1128, 82.817, 212.958, 82.817], end: [56.1128, 82.817, 202.958, 82.817] },
        { start: [66.1128, 95.6339, 212.958, 95.6339], end: [56.1128, 95.6339, 202.958, 95.6339] },
        { start: [72.0282, 108.451, 209.014, 108.451], end: [62.0282, 108.451, 199.014, 108.451] },
        { start: [76.9578, 121.268, 202.113, 121.268], end: [66.9578, 121.268, 192.113, 121.268] },
        { start: [88.7888, 134.085, 190.282, 134.085], end: [78.7888, 134.085, 180.282, 134.085] },
        { start: [97.662, 145.915, 181.408, 145.915], end: [87.662, 145.915, 171.408, 145.915] },
        { start: [120.338, 157.746, 158.732, 157.746], end: [110.338, 157.746, 148.732, 157.746] },
    ];
    const lines = lineSpecs.map(({ start }) => createMotionLine(group, ...start));
    const nodes = [left, right, center, ...lines];

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            group.setAttribute("transform", `translate(${mix(20, 30, eased)} 75)`);
            group.setAttribute("opacity", String(mix(0.5, 1, eased)));
            left.setAttribute("d", phenomenonCrescentPath(85.11, 84.82, 84.82, mix(140.325, 130.325, eased), 84.82, "left"));
            right.setAttribute("d", phenomenonCrescentPath(mix(194.94, 171.94, eased), 84.82, 84.82, mix(140.325, 130.325, eased), 84.82, "right"));
            center.setAttribute("transform", `translate(${-10 * eased} 0)`);
            lines.forEach((line, index) => {
                const { start, end } = lineSpecs[index];
                line.setAttribute("x1", String(mix(start[0], end[0], eased)));
                line.setAttribute("y1", String(mix(start[1], end[1], eased)));
                line.setAttribute("x2", String(mix(start[2], end[2], eased)));
                line.setAttribute("y2", String(mix(start[3], end[3], eased)));
            });
            setMotionPaint(nodes, eased);
        },
    };
}

function renderSocialEtnography() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);

    const rect = document.createElementNS(NS, "rect");
    rect.setAttribute("x", "39.8");
    rect.setAttribute("y", "39.61");
    rect.setAttribute("width", "239.2");
    rect.setAttribute("height", "239.39");
    rect.setAttribute("rx", "4");
    setDashedStroke(rect);

    const circle = document.createElementNS(NS, "circle");
    circle.setAttribute("cx", "160");
    circle.setAttribute("cy", "160");
    circle.setAttribute("r", "102.857");
    setDashedStroke(circle);

    group.append(rect, circle);

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            group.setAttribute("opacity", String(mix(0.5, 1, eased)));
            circle.setAttribute("transform", `rotate(${mix(0, 135, eased)} 160 160)`);
            setMotionPaint([rect, circle], eased);
        },
    };
}

function renderTestareaCandidatilorPolitici() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);
    const starts = [
        { cx: 160, cy: 220, r: 60 },
        { cx: 160, cy: 100, r: 60 },
        { cx: 220, cy: 160, r: 60 },
        { cx: 100, cy: 160, r: 60 },
    ];
    const ends = [
        { cx: 202.426, cy: 202.426, r: 60 },
        { cx: 117.574, cy: 117.574, r: 60 },
        { cx: 202.426, cy: 117.574, r: 60 },
        { cx: 117.574, cy: 202.426, r: 60 },
    ];
    const circles = starts.map((spec) => {
        const circle = document.createElementNS(NS, "circle");
        circle.setAttribute("cx", String(spec.cx));
        circle.setAttribute("cy", String(spec.cy));
        circle.setAttribute("r", String(spec.r));
        setDashedStroke(circle);
        group.appendChild(circle);
        return circle;
    });

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            group.setAttribute("opacity", String(mix(0.5, 1, eased)));
            circles.forEach((circle, index) => {
                const start = starts[index];
                const end = ends[index];
                circle.setAttribute("cx", String(mix(start.cx, end.cx, eased)));
                circle.setAttribute("cy", String(mix(start.cy, end.cy, eased)));
                circle.setAttribute("r", String(mix(start.r, end.r, eased)));
            });
            setMotionPaint(circles, eased);
        },
    };
}

function renderSocialPopulation() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);

    const startPaths = [
        "M155.636 57.0908C155.636 54.8817 153.845 53.0827 151.637 53.1688C139.536 53.6411 127.602 56.254 116.394 60.8966C103.952 66.05 92.6479 73.6035 83.1257 83.1257C73.6035 92.6479 66.05 103.952 60.8966 116.394C56.2539 127.602 53.6411 139.536 53.1688 151.637C53.0827 153.845 54.8817 155.636 57.0908 155.636L151.636 155.636C153.845 155.636 155.636 153.845 155.636 151.636V57.0908Z",
        "M164.364 44C164.364 41.7909 166.155 39.9928 168.363 40.0692C182.184 40.5475 195.819 43.5017 208.616 48.8023C222.646 54.6136 235.393 63.1313 246.131 73.8691C256.869 84.6069 265.387 97.3546 271.198 111.384C276.498 124.181 279.453 137.816 279.931 151.637C280.007 153.845 278.209 155.636 276 155.636L168.364 155.636C166.155 155.636 164.364 153.845 164.364 151.636L164.364 44Z",
        "M164.364 262.909C164.364 265.118 166.155 266.917 168.363 266.831C180.464 266.359 192.398 263.746 203.606 259.103C216.048 253.95 227.352 246.397 236.874 236.874C246.397 227.352 253.95 216.048 259.103 203.606C263.746 192.398 266.359 180.464 266.831 168.363C266.917 166.155 265.118 164.364 262.909 164.364L168.364 164.364C166.155 164.364 164.364 166.155 164.364 168.364V262.909Z",
        "M155.636 276C155.636 278.209 153.845 280.007 151.637 279.931C137.816 279.453 124.181 276.498 111.384 271.198C97.3545 265.386 84.6068 256.869 73.869 246.131C63.1311 235.393 54.6134 222.645 48.8022 208.616C43.5016 195.819 40.5473 182.184 40.069 168.363C39.9926 166.155 41.7907 164.364 43.9999 164.364L151.636 164.364C153.845 164.364 155.636 166.155 155.636 168.364L155.636 276Z",
    ];

    const endPaths = [
        "M156 44C156 41.7909 154.209 39.9928 152.001 40.069C138.132 40.5474 124.45 43.5111 111.609 48.83C97.5349 54.6595 84.7472 63.204 73.9756 73.9756C63.204 84.7472 54.6595 97.535 48.83 111.609C43.5111 124.45 40.5474 138.132 40.069 152.001C39.9928 154.209 41.7909 156 44 156L152 156C154.209 156 156 154.209 156 152V44Z",
        "M164.363 44C164.363 41.7909 166.155 39.9928 168.363 40.0692C182.184 40.5475 195.819 43.5017 208.615 48.8023C222.645 54.6136 235.393 63.1313 246.131 73.8691C256.868 84.6069 265.386 97.3546 271.197 111.384C276.498 124.181 279.452 137.816 279.93 151.637C280.007 153.845 278.209 155.636 276 155.636L168.363 155.636C166.154 155.636 164.363 153.845 164.363 151.636L164.363 44Z",
        "M164 276C164 278.209 165.791 280.007 167.999 279.931C181.868 279.453 195.55 276.489 208.391 271.17C222.465 265.34 235.253 256.796 246.024 246.024C256.796 235.253 265.34 222.465 271.17 208.391C276.489 195.55 279.453 181.868 279.931 167.999C280.007 165.791 278.209 164 276 164L168 164C165.791 164 164 165.791 164 168V276Z",
        "M155.636 276C155.636 278.209 153.845 280.007 151.637 279.931C137.816 279.453 124.181 276.498 111.384 271.198C97.3545 265.386 84.6068 256.869 73.869 246.131C63.1311 235.393 54.6134 222.645 48.8022 208.616C43.5016 195.819 40.5473 182.184 40.069 168.363C39.9926 166.155 41.7907 164.364 43.9999 164.364L151.636 164.364C153.845 164.364 155.636 166.155 155.636 168.364L155.636 276Z",
    ];

    const paths = startPaths.map((d) => createMotionPath(group, d));
    const morphs = startPaths.map((d, index) => createPathMorph(d, endPaths[index]));

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            const stroke = mixColor(INK, PINK, eased);
            const opacity = mix(0.5, 1, eased);

            group.setAttribute("opacity", String(opacity));

            paths.forEach((path, index) => {
                path.setAttribute("d", morphs[index](eased));
                path.setAttribute("stroke", stroke);
                path.setAttribute("stroke-opacity", String(opacity));
            });
        },
    };
}

function renderSocialMassMedia() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);
    const shapePaths = [
        "M242 60.9996C242 28.415 214.681 2 180.983 2C147.284 2 119.966 28.415 119.966 60.9996V119.999H180.983C214.681 119.999 242 93.5842 242 60.9996Z",
        "M217.593 72.799C217.593 46.7313 195.738 25.5993 168.779 25.5993C141.82 25.5993 119.966 46.7313 119.966 72.799V119.999H168.779C195.738 119.999 217.593 98.8666 217.593 72.799Z",
        "M193.186 84.6002C193.186 65.0495 176.795 49.2005 156.576 49.2005C136.356 49.2005 119.966 65.0495 119.966 84.6002V120H156.576C176.795 120 193.186 104.151 193.186 84.6002Z",
        "M168.779 96.3996C168.779 83.3658 157.852 72.7998 144.372 72.7998C130.893 72.7998 119.966 83.3658 119.966 96.3996V119.999H144.372C157.852 119.999 168.779 109.433 168.779 96.3996Z",
        "M242 181.002C242 214.692 214.681 242.003 180.983 242.003C147.284 242.003 119.966 214.692 119.966 181.002V120.001H180.983C214.681 120.001 242 147.312 242 181.002Z",
        "M217.593 168.802C217.593 195.754 195.738 217.603 168.779 217.603C141.82 217.603 119.966 195.754 119.966 168.802V120.001H168.779C195.738 120.001 217.593 141.85 217.593 168.802Z",
        "M193.186 156.6C193.186 176.814 176.795 193.201 156.576 193.201C136.356 193.201 119.966 176.814 119.966 156.6V120H156.576C176.795 120 193.186 136.387 193.186 156.6Z",
        "M168.779 144.401C168.779 157.877 157.852 168.801 144.372 168.801C130.893 168.801 119.966 157.877 119.966 144.401V120.001H144.372C157.852 120.001 168.779 130.925 168.779 144.401Z",
        "M2 60.9996C2 28.415 28.4153 2 61.0002 2C93.5851 2 120 28.415 120 60.9996V119.999H61.0002C28.4153 119.999 2 93.5842 2 60.9996Z",
        "M25.6001 72.799C25.6001 46.7313 46.7323 25.5993 72.8002 25.5993C98.8681 25.5993 120 46.7313 120 72.799V119.999H72.8002C46.7323 119.999 25.6001 98.8666 25.6001 72.799Z",
        "M49.2001 84.6002C49.2001 65.0495 65.0493 49.2005 84.6002 49.2005C104.151 49.2005 120 65.0495 120 84.6002V120H84.6002C65.0493 120 49.2001 104.151 49.2001 84.6002Z",
        "M72.8002 96.3996C72.8002 83.3658 83.3663 72.7998 96.4003 72.7998C109.434 72.7998 120 83.3658 120 96.3996V119.999H96.4003C83.3663 119.999 72.8002 109.433 72.8002 96.3996Z",
        "M2 180.986C2 214.684 28.4153 242.003 61.0002 242.003C93.5851 242.003 120 214.684 120 180.986V119.969H61.0002C28.4153 119.969 2 147.287 2 180.986Z",
        "M25.6001 168.783C25.6001 195.742 46.7323 217.596 72.8002 217.596C98.8681 217.596 120 195.742 120 168.783V119.969H72.8002C46.7323 119.969 25.6001 141.824 25.6001 168.783Z",
        "M49.2001 156.578C49.2001 176.797 65.0493 193.188 84.6002 193.188C104.151 193.188 120 176.797 120 156.578V119.968H84.6002C65.0493 119.968 49.2001 136.359 49.2001 156.578Z",
        "M72.8002 144.375C72.8002 157.855 83.3663 168.782 96.4003 168.782C109.434 168.782 120 157.855 120 144.375V119.968H96.4003C83.3663 119.968 72.8002 130.896 72.8002 144.375Z",
    ];
    const paths = shapePaths.map((d) => createMotionPath(group, d));

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            group.setAttribute("opacity", String(mix(0.5, 1, eased)));
            group.setAttribute("transform", `translate(38 38) rotate(${mix(0, -45, eased)} 122 122)`);
            setMotionPaint(paths, eased);
        },
    };
}

function renderSocialAcademic() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);
    group.setAttribute("transform", "translate(71 38)");

    const starts = [
        { topY: 67.5506, bottomY: 242, leftX: 2, rightX: 176.449, centerX: 89.2247, assetHeight: 244 },
        { topY: 35.8329, bottomY: 210.282, leftX: 2, rightX: 176.449, centerX: 89.2247, assetHeight: 244 },
        { topY: 2, bottomY: 176.449, leftX: 2, rightX: 176.449, centerX: 89.2247, assetHeight: 244 },
    ];
    const ends = [
        { topY: 2, bottomY: 176.449, leftX: 2.00002, rightX: 176.449, centerX: 89.2247, assetHeight: 178.449 },
        { topY: 2.4494, bottomY: 144.449, leftX: 2.00002, rightX: 176, centerX: 89, assetHeight: 178.449 },
        { topY: 2.4494, bottomY: 110.449, leftX: 2.00002, rightX: 176, centerX: 89, assetHeight: 178.449 },
    ];
    const paths = starts.map((spec) =>
        createMotionPath(group, academicTrianglePath(spec.topY, spec.bottomY, spec.leftX, spec.rightX, spec.centerX)),
    );

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            group.setAttribute("opacity", String(mix(0.5, 1, eased)));
            group.setAttribute("transform", `translate(71 ${mix(38, 73, eased)})`);
            paths.forEach((path, index) => {
                const start = starts[index];
                const end = ends[index];
                path.setAttribute(
                    "d",
                    academicTrianglePath(
                        mix(start.topY, end.topY, eased),
                        mix(start.bottomY, end.bottomY, eased),
                        mix(start.leftX, end.leftX, eased),
                        mix(start.rightX, end.rightX, eased),
                        mix(start.centerX, end.centerX, eased),
                        mix(start.assetHeight, end.assetHeight, eased),
                    ),
                );
            });
            setMotionPaint(paths, eased);
        },
    };
}

function renderLongitudinalStudy() {
    const svg = createMotionSvg();
    const group = document.createElementNS(NS, "g");
    svg.appendChild(group);

    const ellipses = [
        {
            node: createMotionEllipse(group, 186.905, 132.905, 92.905, 92.905),
            start: { cx: 186.905, cy: 132.905, rx: 92.905, ry: 92.905 },
            end: { cx: 230, cy: 90, rx: 75, ry: 75 },
        },
        {
            node: createMotionEllipse(group, 160.135, 160.005, 92.905, 92.905),
            start: { cx: 160.135, cy: 160.005, rx: 92.905, ry: 92.905 },
            end: { cx: 160, cy: 160, rx: 70, ry: 70 },
        },
        {
            node: createMotionEllipse(group, 130.905, 187.095, 92.905, 92.905),
            start: { cx: 130.905, cy: 187.095, rx: 92.905, ry: 92.905 },
            end: { cx: 85, cy: 245, rx: 55, ry: 55 },
        },
    ];

    return {
        node: svg,
        apply(progress) {
            const eased = easeMotion(progress);
            group.setAttribute("opacity", String(mix(0.5, 1, eased)));
            ellipses.forEach(({ node, start, end }) => {
                node.setAttribute("cx", String(mix(start.cx, end.cx, eased)));
                node.setAttribute("cy", String(mix(start.cy, end.cy, eased)));
                node.setAttribute("rx", String(mix(start.rx, end.rx, eased)));
                node.setAttribute("ry", String(mix(start.ry, end.ry, eased)));
            });
            setMotionPaint(ellipses.map((item) => item.node), eased);
        },
    };
}

export { renderSocialPhenomenon, renderSocialEtnography, renderTestareaCandidatilorPolitici, renderSocialPopulation, renderSocialMassMedia, renderSocialAcademic, renderLongitudinalStudy };
